import * as ko from 'knockout';

import { BaseControl, IControlValue } from 'Core/Controls/BaseControl/BaseControl';
import { IControlParam } from 'Core/Screens/IScreen';
import { RenderModes } from 'Core/Constant';

import ConfigJson from 'Core/Controls/IFrameExtension/Configs/config.json';
import { GeneralProperties } from 'Core/GeneralProperties/GeneralProperties';
import { PROPERTIES } from 'Core/Controls/IFrameExtension/Constants';

import ViewTemplate from 'Core/Controls/IFrameExtension/Templates/View.html';
import ToolBarTemplate from 'Core/Controls/IFrameExtension/Templates/ToolBar.html';
import DesignTemplate from 'Core/Controls/IFrameExtension/Templates/Design.html';
import { CookieManager } from '../../Common/CookieManager';
import { frameExtensionFacade } from 'Core/Components/CustomFunctions/Facades/IFrameExtensionFacade';
import { IFieldDataModel, RecordStore } from 'Core/Common/Stores/RecordStore';
import { error } from 'jquery';

ko.templates['Core/Controls/IFrameExtension/Templates/ToolBar'] = ToolBarTemplate;
ko.templates['Core/Controls/IFrameExtension/Templates/View'] = ViewTemplate;
ko.templates['Core/Controls/IFrameExtension/Templates/Edit'] = ViewTemplate;
ko.templates['Core/Controls/IFrameExtension/Templates/Design'] = DesignTemplate;

export interface IControlMounted {
    control: any;
}

export class IFrameExtension extends BaseControl {
    private _url: KnockoutObservable<string>;
    private _heightPX: KnockoutObservable<number>;

    constructor(params: IControlParam) {
        super(params, ConfigJson);

        this.Init();
        this._model.subscribe(() => {
            if (this.Properties) {
                this.ApplyProperties();
            }
        });
    }

    Init(): void {
        this._heightPX = ko.observable(null);
        this.ApplyProperties();
    }

    GetDesignerHeight(): string {
        return `${+this._heightPX()}px`;
    }

    SetValue(value: IControlValue): void {        
        const token = CookieManager.GetAuthToken();
        this._url = ko.observable(
            `/api/IFrameExtensionApi/Index/${this.GetControlId()}/?access_token=${token}`
        );
    }

    ApplyProperties() {
        this._heightPX(
            !!this.GeneralProperties.GetPropertyValue(PROPERTIES.HEIGHT_PX)
                ? this.GeneralProperties.GetPropertyValue(PROPERTIES.HEIGHT_PX)
                : null
        );
    }
    FrameLoaded(_, evt) {

        evt.currentTarget.contentWindow['Spheeres'].updateRecord = async function (record) {
            return new Promise(async (resolve, reject) => {
                const id = record.recordId;
                const tableName = Object.keys(record)[1];

                let fields: IFieldDataModel[] = [];
                let fieldObject = record[tableName];

                Object.keys(fieldObject).forEach((key) => {
                    fields.push({
                        Name: key,
                        Value: fieldObject[key],
                    });
                });

                let createRecordResult = await RecordStore.UpdateRecord({
                    RecordId: Number(id),
                    TableName: tableName,
                    Fields: fields,
                    RequiredValidation: false,
                }).fail((error) => reject(JSON.parse(error.message).Message));
                resolve(createRecordResult);
            });
        };

        evt.currentTarget.contentWindow['Spheeres'].createRecord = async function (record) {
            return new Promise(async (resolve, reject) => {
                const tableName = Object.keys(record)[0];

                let fields: IFieldDataModel[] = [];
                let fieldObject = record[tableName];

                Object.keys(fieldObject).forEach((key) => {
                    fields.push({
                        Name: key,
                        Value: fieldObject[key],
                    });
                });

                let createRecordResult = await RecordStore.CreateRecord({
                    TableName: tableName,
                    Fields: fields,
                    RequiredValidation: false,
                }).fail((error) => reject(JSON.parse(error.message).Message));
                resolve(createRecordResult);
            });
        };

        evt.currentTarget.contentWindow['Spheeres'].$subjectRecordId = this.Screen.GetRecordId();

        evt.currentTarget.contentWindow['Spheeres'].getDataFromQuery = async function ({ name, take = 100, subjectRecordId }: { name: string, take: number, subjectRecordId: number }) {
            const MAX_PER_REQUEST = 1000;
            const allRecords = [];
            let remaining = take;
            let page = 1;
            let hasMore = true;

            try {
                while (hasMore && remaining > 0) {
                    const recordsToFetch = Math.min(remaining, MAX_PER_REQUEST);

                    const queryData = await RecordStore.GetByQuery({
                        Name: name,
                        RecordsPerPage: recordsToFetch,
                        PageNumber: page,
                        SkipSecurity: true,
                        RecordId: subjectRecordId,
                    }).fail((error) => {
                        throw JSON.parse(error.message).Message;
                    });

                    const records = queryData?.Records || [];
                    allRecords.push(...records);

                    if (records.length < recordsToFetch) {
                        hasMore = false;
                    } else {
                        page++;
                        remaining -= records.length;
                    }
                }

                return allRecords;
            } catch (error) {
                throw error;
            }
        };

        evt.currentTarget.contentWindow['Spheeres'].createLink = async function (link) {
            return new Promise(async (resolve, reject) => {
                try {
                    const keys = Object.keys(link);

                    let leftTable, rightTable, leftId, rightId;

                    if (keys.length === 1) {
                        const table = keys[0];
                        const ids = Array.isArray(link[table]) ? link[table] : [];

                        leftTable = rightTable = table;
                        [leftId, rightId] = ids;
                    } else {
                        leftTable = keys[0];
                        rightTable = keys[1];
                        leftId = link[leftTable];
                        rightId = link[rightTable];
                    }

                    const linkResult = await RecordStore.CreateLinkRecord({
                        LeftTableName: leftTable,
                        LeftRecordId: leftId,
                        RightTableName: rightTable,
                        RightRecordId: rightId,
                    }).fail((error) => reject(JSON.parse(error.message).Message));

                    resolve(linkResult);
                } catch (err) {
                    reject(err.message || err);
                }
            });
        };

        evt.currentTarget.contentWindow['Spheeres'].deleteLink = async function (link) {
            return new Promise(async (resolve, reject) => {
                try {
                    const sequenceId = link.linkId || null;

                    const keys = Object.keys(link).filter(k => k !== 'linkId');

                    let leftTable, rightTable, leftId, rightId;

                    if (keys.length === 1) {
                        const table = keys[0];
                        const ids = Array.isArray(link[table]) ? link[table] : [];

                        leftTable = rightTable = table;
                        [leftId, rightId] = ids;
                    } else {
                        leftTable = keys[0];
                        rightTable = keys[1];
                        leftId = link[leftTable];
                        rightId = link[rightTable];
                    }

                    const deleteResult = await RecordStore.DeleteLinkRecord({
                        LinkId: sequenceId,
                        LeftTableName: leftTable,
                        LeftRecordId: leftId,
                        RightTableName: rightTable,
                        RightRecordId: rightId,
                    }).fail((error) => reject(JSON.parse(error.message).Message));

                    resolve(deleteResult);
                } catch (err) {
                    reject(err.message || err);
                }
            });
        };

        const event = new CustomEvent('controlMounted', {
            detail: { control: frameExtensionFacade(this) },
        });
        evt.currentTarget.contentWindow.dispatchEvent(event);
    }

    Inject(contentWindow: any) {
        contentWindow.Spheeres = {};
        contentWindow.Spheeres.onReady = (callback: Function) => {
            callback();
        };
    }
}
